import { Controller } from "@hotwired/stimulus"
import TinyMceEditor from "../lib/tinymce_editor"

export default class extends Controller {
  static targets = ["form"]
  static values = {
    editorId: String,
    imagePickerUrl: String,
    iconPickerUrl: String,
    fontsCss: Array
  }

  connect() {
    this.editor = new TinyMceEditor(
      this.editorIdValue,
      this.formTarget,
      this.imagePickerUrlValue,
      this.iconPickerUrlValue,
      this.fontsCssValue
    )
    this.boundKeydownHandler = this.handleKeydown.bind(this)
    document.addEventListener('keydown', this.boundKeydownHandler, { capture: true })
  }

  disconnect() {
    if (this.editor) {
      this.editor.destroy()
    }
    document.removeEventListener('keydown', this.boundKeydownHandler, { capture: true })
  }

  handleKeydown(e) {
    if ((e.ctrlKey || e.metaKey) && e.key === 's' && this.hasFormTarget) {
      e.preventDefault()
      this.formTarget.requestSubmit()
    }
  }
}
